module.exports = __webpack_public_path__ + "assets/w3w_logo-532b39d1b07926c7d1ca2b7055614412.png";